import DangerAlert from './danger';
import HighlightAlert from './highlight';
import InfoAlert from './info';
import PlainAlert from './plain';
import SuccessAlert from './success';
import WarningAlert from './warning';

export { DangerAlert, HighlightAlert, InfoAlert, PlainAlert, SuccessAlert, WarningAlert };
